import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

// Any string is accepted by the server because we want to add new surfaces
// without a deploy of the dto package; the union below is purely advisory and
// drives the admin filter dropdown.
export const FEEDBACK_SURFACES = [
  "topbar_widget",
  "post_download",
  "post_interview",
  "rate_template",
  "exit_intercept",
  "nps_card",
] as const;
// `string & NonNullable<unknown>` is the lint-friendly equivalent of
// `string & {}` — keeps autocomplete on the literal union while still
// allowing arbitrary strings (for surfaces shipped after this dto release).
export type FeedbackSurface = (typeof FEEDBACK_SURFACES)[number] | (string & NonNullable<unknown>);

export const submitFeedbackSchema = z.object({
  kind: z.enum(["GENERAL", "NPS_FOLLOWUP", "EXIT_SURVEY", "BUG_REPORT"]),
  surface: z.string().min(1).max(64),
  // 0..10 covers NPS; CSAT (1..5) and template ratings fit too. Server clamps.
  rating: z.number().int().min(0).max(10).nullable().optional(),
  message: z.string().min(3, "Please add a few more characters").max(4000),
  // Optional for guests; required by the server when no session user is found.
  email: z.string().email().optional(),
  tags: z.array(z.string().min(1).max(32)).max(10).optional(),
  // Free-form bag — route, planAtSubmit, posthog $survey_id + questionId,
  // locale, etc. Anything sensitive should be omitted by the client.
  context: z.record(z.unknown()).optional(),
});

export class SubmitFeedbackDto extends createZodDto(submitFeedbackSchema) {}

export type SubmitFeedbackPayload = z.infer<typeof submitFeedbackSchema>;
